/**
 * Theme Toggle Button
 *
 * Cycles through: System → Light → Dark → System
 * Displays the current mode with an icon only
 */
import React, { useContext } from "react";

/**
 * Contexts
 */
import { ThemeContext } from "contexts/ThemeContext";

/**
 * Icons for each theme preference
 */
const ThemeIcons = {
  system: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 3.5C2 2.67157 2.67157 2 3.5 2H12.5C13.3284 2 14 2.67157 14 3.5V10.5C14 11.3284 13.3284 12 12.5 12H3.5C2.67157 12 2 11.3284 2 10.5V3.5Z"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path d="M5.5 14H10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M8 12V14" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  ),
  light: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="3.25" stroke="currentColor" strokeWidth="1.2" />
      <path d="M8 1.5V3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M8 13V14.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M3.4 3.4L4.46 4.46" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M11.54 11.54L12.6 12.6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M1.5 8H3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M13 8H14.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M3.4 12.6L4.46 11.54" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M11.54 4.46L12.6 3.4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
  dark: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 9.5C12.6 10.1 11.5 10.5 10.3 10.5C7.0 10.5 4.3 7.8 4.3 4.5C4.3 3.6 4.5 2.7 4.9 1.9C3.0 3.0 1.8 5.0 1.8 7.3C1.8 10.8 4.6 13.6 8.1 13.6C10.7 13.6 12.9 12.0 13.5 9.5Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

/**
 * Tooltip labels for each theme preference
 */
const ThemeLabels = {
  system: "Auto (System)",
  light: "Light mode",
  dark: "Dark mode",
};

/**
 * Theme Toggle component
 * Icon-only button in the sidebar to cycle through theme preferences
 */
export default function ThemeToggle() {
  const { preference, cycleTheme } = useContext(ThemeContext);

  return (
    <button
      className="wotodo-theme-toggle"
      onClick={cycleTheme}
      title={`${ThemeLabels[preference]} — click to change`}
    >
      {ThemeIcons[preference]}
    </button>
  );
}
